import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ExternalRedirectResolver implements Resolve<any> {
  private platformId = inject(PLATFORM_ID);

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    // Only redirect in browser environment
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = 'https://onelink.to/t4qj33'; 
    }
    return null;
  }
}